import { useRef } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import config from './config'
import Masthead from '../../components/Masthead'
import { SnackbarProvider } from 'notistack';
import './style.css'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AppInstructions from '../../components/AppInstructions';

const Template = props => {

    const snackRef = useRef( null );

    /**
     * @name dismiss
     * @function
     * @description creates a dismiss button 
     * @returns {ReactComponentElement}
     */
    const dismiss = () => (
        <IconButton onClick={ () => snackRef.current.closeSnackbar() } aria-label="Close">
            <CloseIcon />
        </IconButton>
    );

    return (
        <ThemeProvider theme={ config }>
            <SnackbarProvider 
                action={ dismiss }
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                autoHideDuration={ ( 1000 * 15 ) } 
                maxSnack={ 5 } 
                ref={ snackRef }>
                <Masthead />
                <AppInstructions />
                { props.children }
            </SnackbarProvider>
        </ThemeProvider>
    )
}

export default Template